import { Link } from 'react-router'

import { paths } from '@/app/router/paths'
import { SidebarNav } from '@/components/layout/SidebarNav'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { env } from '@/config/env'
import { useUiStore } from '@/stores/ui.store'
import { cn } from '@/lib/utils'

function Brand({ collapsed }: { collapsed: boolean }) {
  return (
    <Link
      to={paths.projects.pipeline}
      className="border-sidebar-border flex h-14 items-center gap-2 border-b px-4"
    >
      <img src="/logo-mark.svg" alt="" className="h-8 w-auto shrink-0" aria-hidden />
      {!collapsed ? (
        <span className="font-display truncate text-xl font-bold tracking-[-0.01em]">
          {env.appName}
        </span>
      ) : null}
    </Link>
  )
}

/** Persistent rail on desktop. */
export function DesktopSidebar() {
  const collapsed = useUiStore((state) => state.sidebarCollapsed)

  return (
    <aside
      className={cn(
        'bg-sidebar border-sidebar-border hidden shrink-0 border-r transition-[width] duration-200 md:block',
        collapsed ? 'w-16' : 'w-64',
      )}
    >
      <div className="sticky top-0 flex h-dvh flex-col">
        <Brand collapsed={collapsed} />
        <div className="flex-1 overflow-y-auto">
          <SidebarNav collapsed={collapsed} />
        </div>
      </div>
    </aside>
  )
}

/** Slide-over on mobile; open state lives with the shell, not the store. */
export function MobileSidebar({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="bg-sidebar w-72 p-0">
        <SheetHeader className="sr-only">
          <SheetTitle>Navigation</SheetTitle>
        </SheetHeader>
        <Brand collapsed={false} />
        <SidebarNav onNavigate={() => onOpenChange(false)} />
      </SheetContent>
    </Sheet>
  )
}
